import { CinemaModel } from '../cinemas';
import { ExperienceModel } from '../experiences';
import { Film } from '../movies';
import { Pagination } from '../general/models';

export enum TimeDuration {
  ALL_DAY = 'ALL_DAY',
  MORNING = 'MORNING',
  AFTERNOON = 'AFTERNOON',
  EVENING = 'EVENING',
  AFTER_MIDNIGHT = 'AFTER_MIDNIGHT',
}
export interface FinderDatesResponse {
  avaliableDates: AvaliableDate[];
}

export interface AvaliableDate {
  date: string;
}

export interface FinderFilm extends Film {
  isDisabled: boolean;
}

export interface FinderFiltersResponse {
  experiences: ExperienceModel[];
  cinemas: CinemaModel[];
  films: FinderFilm[];
  totalResultCount?: number;
}

export interface FinderFiltersFilm {
  films: FinderFilm[];
}
export interface FinderFiltersCinemas {
  cinemas: CinemaModel[];
}
export interface FinderFiltersExperiences {
  experiences: ExperienceModel[];
}
export interface FinderResultsCount {
  totalResultCount: number;
}

export interface FinderResultsRequest {
  cityId: number;
  date: string;
  timeDuration: string;
  filmIds?: number[];
  cinemaIds?: number[];
  experienceIds?: number[];
}
export interface FinderResultsResponse {
  data: FinderResultModel[];
  pagination: Pagination;
}

export type FinderResultModel = Film;

export interface dataSearch {
  data: RecentSearchModel[];
}

export interface RecentSearchModel {
  name: string;
  searchableType: string;
  searchableId: number;
  isDisabled: boolean;
}

export interface RecentAddSearchModel {
  searchableId: string;
  searchableType: 'CINEMA' | 'EXPERIENCE' | 'FILM';
}
